import { render } from "./CustomerEditModal.vue?vue&type=template&id=6abad57d"
import script from "./CustomerEditModal.vue?vue&type=script&lang=js"
export * from "./CustomerEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__